import { z } from 'zod';
import { clientDetailedSchema } from '../../GET/client/response';
import { careRequirementsSchema } from '../../common/basic/careRequirement';
import { date } from '../../common/atomic/date';

export const createClientSchema = clientDetailedSchema
  .pick({
    firstName: true,
    lastName: true,
    title: true,
    sex: true,
    birthdate: true,
    phone: true,
    email: true,
    contacts: true,
    servAddress: true,
    permAddress: true,
  })
  .merge(
    z.object({
      serviceId: z.number(), // for automatic careplan creation
      tags: z.array(z.number()),
      applicantData: z.object({
        careReq: careRequirementsSchema,
        statusDesc: z.string(),
        note: z.string().nullable(),
        keyEmp: z.number(),
      }),
    })
  );

export const createClientCarePlane = z.object({
  serviceId: z.number(),
  keyEmpId: z.number().optional(),
  applicantId: z.number(),
  mobility: z.string().optional(),
  goal: z.string().optional(),
  healthDesc: z.string().optional(),
  sitDesc: z.string().optional(),
  risks: z.string().optional(),
  reqCare: z.string().optional(),
  note: z.string().optional(),
  noteCoord: z.string().optional(),
  noteCaregiver: z.string().optional(),
  clientRes: z.string().optional(),
  lastRevDate: date.optional(),
  nextRevDate: date.optional(),
  expDate: date.optional(),
});

export type CreateClient = z.infer<typeof createClientSchema>;
export type CreateClientCarePlan = z.infer<typeof createClientCarePlane>;

export const defaultClient: CreateClient = {
  firstName: '',
  lastName: '',
  title: '',
  sex: 'O', 
  birthdate: '', 
  phone: '',
  email: '',
  contacts: [
    {
      firstName: '',
      lastName: '',
      phone: '',
      email: '',
      relation: '',
    },
  ],
  servAddress: {
    street: '',
    city: '',
    postCode: '',
    descNum: 0,
    orientNum: 0,
  },
  permAddress: {
    street: '',
    city: '',
    postCode: '',
    descNum: 0,
    orientNum: 0,
  },
  serviceId: 0,
  tags: [],
  applicantData: {
    careReq: [],
    statusDesc: '',
    note: null,
    keyEmp: 1, 
  },
};